import { useCallback, useEffect, useState } from 'react';
import { httpGet } from '../../utils';
import { Entity } from './EntitiesTypes';
import { HTTP_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';

const useEntitiesSearch = (
    searchQuery: string,
    types: (string | number)[],
    hideDeleted?: boolean
): { entities: Entity[]; isLoading: boolean } => {
    const [results, setResults] = useState<Entity[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const fetchData = useCallback(async () => {
        if (!searchQuery) {
            setResults([]);
            return;
        }
        setIsLoading(true);
        const entityData: {
            data: {
                Results: Entity[];
            } | null;
        } = await httpGet(`/users/searchEntitiesByTypes/${searchQuery}`, {
            [HTTP_OPTIONS.REQ_OPTIONS]: {
                params: {
                    hideDeleted: hideDeleted !== undefined ? hideDeleted : true,
                    entitiesTypes: types ? types : undefined,
                    authTypes: ['ad']
                }
            }
        });

        if (!entityData.data || !entityData.data.Results) {
            setResults([]);
        } else {
            setResults(entityData.data.Results);
        }
        setIsLoading(false);
    }, [searchQuery, types, hideDeleted]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return { entities: results, isLoading };
};

export default useEntitiesSearch;
